module.exports = __webpack_public_path__ + "img/585.cc56f0bb.png";